import React from "react";
import PropTypes from "prop-types";

import { Container } from "../../atoms/Container";

const InfiniteScrollContainer = (props) => {
  window.onscroll = () => {
    const { error, isLoading, hasMore, fetchMore, showMoreButtonRef } = props;

    if (error || isLoading || !hasMore) return;

    // Fetch more if the user has scrolled past the show more button
    window.innerHeight + window.scrollY >= showMoreButtonRef?.current?.offsetTop && fetchMore();
  };

  const { children } = props;

  return <Container>{children}</Container>;
};

InfiniteScrollContainer.propTypes = {
  children: PropTypes.node.isRequired,
  error: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  hasMore: PropTypes.bool.isRequired,
  fetchMore: PropTypes.func.isRequired,
  showMoreButtonRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }).isRequired,
};

InfiniteScrollContainer.defaultProps = {
  error: null,
};

export default InfiniteScrollContainer;
